import _curry1 from './private/curry1.js';
const toUpper = _curry1( (str) => {
  	return str.toUpperCase();
});
export default toUpper;


// WEBPACK FOOTER //
// ./src/common/bare-metal/toUpper.js